<template>
  <form v-on:submit.prevent="submitForm">

    <h2>Tenders</h2>
    <div class="form-group"><label for="tenderCode">Tender Code : </label><input class="form-control" id="tenderCode" v-model="tender.tenderCode"/></div>
    <div class="form-group"><label for="tenderName">Tender Name : </label><input class="form-control" id="tenderName" v-model="tender.tenderName"/></div>
    <div class="form-group"><label for="tenderType">Tender Type : </label><input class="form-control" id="tenderType" v-model="tender.tenderType"/></div>
    <div class="form-group"><label for="tenderGroup">Tender Group : </label><input class="form-control" id="tenderGroup" v-model="tender.tenderGroup"/></div>
    <div>
      <p>
        <input class="btn btn-edit" type="submit" value="Submit">
      </p>

      <router-link class="btn btn-cancel" v-bind:to="{path: 'tenders'}">
        <v-icon>mdi-cancel</v-icon>
        <input class="btn" type="submit" value="Cancel">
      </router-link>
    </div>
  </form>
</template>

<script>

import {httpClient} from "../../requesters/httpClient";
import {parameters} from "../../parameters";

export default {
  name: 'NewTender',

  data() {
    return {
      tender: {
        tenderCode: '',
        tenderName: '',
        tenderType: '',
        tenderGroup: ''
      }
    }
  },
  methods: {
    async submitForm(e) {
      await httpClient.post(`${parameters.posdataRefUrl}/tenders`, this.tender);

      await this.$alert("The tender was overwritten THEN updated");

      await this.$router.push('tenders');

      e.preventDefault();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tenders/NewTender.vue